export const flagOptions = [
    {
        value: "danger",
        label: "Danger / Red",
    },
    {
        value: "warning",
        label: "Warning / Yellow",
    },
    {
        value: "success",
        label: "Success / Green",
    },
    {
        value: "light",
        label: "Light / White",
    },
    {
        value: "info",
        label: "Info / Blue",
    },
];

export const attributeIsSet = (attribute) => attribute !== null && attribute !== undefined && attribute !== "" && attribute !== false && !Number.isNaN(attribute);
